import type { ReactNode } from "react";
import { EllipsisVertical, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type CardAction = {
  label?: string;
  icon?: ReactNode;
  onClick?: (row: unknown) => void;
  isDisabled?: (row: unknown) => boolean;
};

type Props = {
  actions: CardAction[];
  row: unknown;
  onPrimaryAction?: () => void;
  disabled?: boolean;
};

export function PatientV2ExpandableCardActions({
  actions,
  row,
  onPrimaryAction,
  disabled = false,
}: Props) {
  if (!onPrimaryAction && actions.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="sm"
          variant="ghost"
          className="h-7 w-7 shrink-0 p-0 !bg-transparent  hover:!bg-transparent hover:text-[#111827] focus:!bg-transparent data-[state=open]:!bg-transparent"          
          onClick={(e) => e.stopPropagation()}
          title="More actions"
          disabled={disabled}
        >
          <EllipsisVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        {onPrimaryAction ? (
          <DropdownMenuItem
            onSelect={(e) => {
              e.preventDefault();
              onPrimaryAction();
            }}
          >
            <Pencil className="h-4 w-4" />
            Edit
          </DropdownMenuItem>
        ) : null}
        {actions.map((action, idx) => (
          <DropdownMenuItem
            key={`${action.label ?? "action"}-${idx}`}
            disabled={action.isDisabled?.(row)}
            onSelect={(e) => {
              e.preventDefault();
              action.onClick?.(row);
            }}
          >
            {action.icon}
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
